import React, { useState } from 'react';
import { Tables, showToast } from '@deeptrue-frontend/ui';
import { GroupType } from 'pages/OrganizationAdmin/types';
import RemoveModal from 'components/PromptModal/PromptModal';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import ModalWithTitle from 'components/Modal/ModalWIthTitle';
import Forms from 'components/Forms';
import api from 'api';
import { FormValues } from 'components/Forms/Organization/EditGroup';
import { FormikHelpers } from 'formik';
import GroupIcon from '@material-ui/icons/Group';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { RouteComponentProps } from 'react-router-dom';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import CategoryIcon from '@material-ui/icons/Category';
import { useFormatMessage } from 'components/IntlProvider';

const { withRouter } = RouterProvider;
const { TableRow, TableCell } = Tables;

interface Props extends RouteComponentProps {
  groupData: GroupType;
  organizationCodename: string;
  refetchGroups: () => void;
}

const Group = ({
  groupData,
  organizationCodename,
  refetchGroups,
  history,
}: Props) => {
  const [isEditing, setIsEditing] = useState(false);
  const t = useFormatMessage();

  const updateGroup = (
    values: FormValues,
    { setErrors }: FormikHelpers<FormValues>
  ) => {
    return api.resources.organization.groups
      .updateGroup({
        organizationCodename: organizationCodename,
        groupId: groupData.id,
        data: values,
      })
      .then(() => {
        setIsEditing(false);
        showToast({
          type: 'success',
          title: t('organization.updated', '{name} updated', {
            name: t('organization.group', 'Group'),
          }),
        });
        refetchGroups();
      })
      .catch((err) => {
        setErrors(err.response.data);
      });
  };

  const deleteGroup = () => {
    return api.resources.organization.groups
      .deleteGroup({
        organizationCodename,
        groupId: groupData.id,
      })
      .then(() => {
        showToast({
          type: 'success',
          title: t('organization.deleted', '{name} deleted', {
            name: t('organization.group', 'Group'),
          }),
        });
        refetchGroups();
      });
  };

  return (
    <TableRow>
      <TableCell height="2rem" padding="0.5rem">
        {groupData.name}
      </TableCell>

      <TableCell height="2rem" padding="0.5rem">
        <Tooltip title={t('organization.edit', 'Edit')}>
          <EditIcon
            onClick={() => setIsEditing(true)}
            style={{ cursor: 'pointer', margin: '0 2px' }}
          />
        </Tooltip>

        <Tooltip title={t('organization.users', 'Users')}>
          <GroupIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(
                `/organization/groups/${groupData.id}/shared?tab=users`
              )
            }
          />
        </Tooltip>
        <Tooltip
          title={t('organization.shared', 'Shared {name}', {
            name: t('organization.projects', 'Projects'),
          })}
        >
          <AccountTreeIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(
                `/organization/groups/${groupData.id}/shared?tab=projects`
              )
            }
          />
        </Tooltip>
        <Tooltip
          title={t('organization.shared', 'Shared {name}', {
            name: t('organization.products', 'Products'),
          })}
        >
          <CategoryIcon
            style={{ cursor: 'pointer', margin: '0 2px' }}
            onClick={() =>
              history.push(
                `/organization/groups/${groupData.id}/shared?tab=products`
              )
            }
          />
        </Tooltip>
        <Tooltip
          title={t('organization.delete', 'Delete group', {
            name: t('organization.group', 'Group'),
          })}
        >
          <span style={{ cursor: 'pointer' }}>
            <RemoveModal
              onConfirm={deleteGroup}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              <>
                {t(
                  'organization.confirmDelete',
                  'Are you sure you want to remove {x} from {y}',
                  {
                    x: t('organization.user', 'user'),
                    y: t('organization.group', 'group'),
                  }
                )}
              </>
            </RemoveModal>
          </span>
        </Tooltip>
      </TableCell>
      <ModalWithTitle
        title={t('organization.edit', 'Edit group', {
          name: t('organization.group', 'Group'),
        })}
        open={isEditing}
        onClose={() => setIsEditing(false)}
      >
        <Forms.EditGroupInOrganization
          onSubmit={updateGroup}
          closeModal={() => setIsEditing(false)}
          initialValues={groupData}
        />
      </ModalWithTitle>
    </TableRow>
  );
};

export default withRouter(Group);
